export const getStorage = (key: string) => {
    const value = localStorage.getItem(key) || ''

    try {
        return JSON.parse(value)
    } catch {
        return value
    }
}
